import { AuxiliaryAIRawLoaderConnection, RawLoaderConnection } from "./raw-loader-connection"

export const RawLoader = await RawLoaderConnection.connect()

export const AuxiliaryAIRawLoader = await AuxiliaryAIRawLoaderConnection.connect()
